<script setup>
import { useLayout } from '@/composables/layout';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { layoutConfig } = useLayout();
const { locale } = useI18n();

// Gestione tema scuro
window.addEventListener('storage', (e) => {
    if (e.key === 'app-dark-theme') {
        document.documentElement.classList.toggle('app-dark', JSON.parse(e.newValue));
    }
    // Gestione cambio lingua tra tab
    if (e.key === 'app-language') {
        locale.value = e.newValue;
    }
});

const savedDark = JSON.parse(localStorage.getItem('app-dark-theme') || 'false');
document.documentElement.classList.toggle('app-dark', savedDark);

// Inizializza la lingua da localStorage
const savedLanguage = localStorage.getItem('app-language');
if (savedLanguage) {
    locale.value = savedLanguage;
}

// Sincronizza i18n con layoutConfig
watch(() => layoutConfig.language, (newLang) => {
    if (newLang && locale.value !== newLang) {
        locale.value = newLang;
    }
}, { immediate: true });
</script>

<template>
    <router-view />
</template>